import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import { Heading } from '~/components/Heading';
import { Box } from '~/components/Layout/Box';
import { Stack } from '~/components/Layout/Stack';
import { NUpCtaDesktop, NUpCtaMobile } from '~/components/marketing/NUpTripContainer/src/NUpCta';
import colorStyles from '~/components/Utilities/ColourCombinations/ColourCombinations.module.css';
import styles from './Section.module.css';
import type { SectionProps } from './Section.types';
const Section = t0 => {
  const $ = _c(23);
  const {
    colour: t1,
    children,
    description,
    title,
    superTitle,
    isCentered,
    isFullBleed,
    isRounded,
    hasLinkCta,
    hasMobileLinkCta: t2
  } = t0;
  const colour = t1 === undefined ? "defaultBackground" : t1;
  const hasMobileLinkCta = t2 === undefined ? true : t2;
  const backgroundStyle = colour && colorStyles[colour];
  const vertSpacing = colour !== "defaultBackground" ? "--by-space-1400" : 0;
  const t3 = !isFullBleed;
  let t4;
  if ($[0] !== backgroundStyle || $[1] !== isRounded || $[2] !== t3) {
    t4 = clsx(backgroundStyle, {
      [styles.container]: t3,
      [styles.rounded]: isRounded
    });
    $[0] = backgroundStyle;
    $[1] = isRounded;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== description || $[5] !== hasLinkCta || $[6] !== superTitle || $[7] !== title) {
    t5 = title || description ? <div>{title && superTitle && <p className={styles.superTitle} itemScope={true} itemType="https://schema.org/CreativeWork"><span itemProp="alternativeHeadline">{superTitle}</span></p>}{title && <div className={clsx(hasLinkCta && styles.titleRow)}><Heading level="h2" variant="heading-md">{title}</Heading>{hasLinkCta && <NUpCtaDesktop />}</div>}{description && <p className={styles.description}>{description}</p>}</div> : null;
    $[4] = description;
    $[5] = hasLinkCta;
    $[6] = superTitle;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== hasLinkCta || $[10] !== hasMobileLinkCta) {
    t6 = hasLinkCta && hasMobileLinkCta && <NUpCtaMobile />;
    $[9] = hasLinkCta;
    $[10] = hasMobileLinkCta;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== children || $[13] !== t5 || $[14] !== t6) {
    t7 = <Stack space="--by-space-400">{t5}{children}{t6}</Stack>;
    $[12] = children;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isCentered || $[17] !== t7 || $[18] !== vertSpacing) {
    t8 = <Box spaceHorizontal="--by-space-400" mdSpaceHorizontal={0} spaceVertical={vertSpacing} isContainer={true} isCentered={isCentered}>{t7}</Box>;
    $[16] = isCentered;
    $[17] = t7;
    $[18] = vertSpacing;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t4 || $[21] !== t8) {
    t9 = <section data-test-id="Section" className={t4}>{t8}</section>;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export { Section };